import React from 'react'
import ReportCallDetailPage from "./ReportCallDetailPage"

const ReportCallDetailContainer = () => {
    return (
        <div className="ReportCallDetailContainer">
            <ReportCallDetailPage/>
        </div>
    )
}

export default ReportCallDetailContainer
